import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import AOS from "aos";
import VueAnalytics from 'vue-analytics';
import "aos/dist/aos.css";

AOS.init({
  once: true
});

Vue.config.productionTip = false;
Vue.use(VueAnalytics, {
  id: 'UA-17568976-1',
  router
});

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");